import { useMemo } from "react";

import { smsTemplatesApi } from "@/api";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { TemplateManagement } from "@/pages/system-settings/tabs/templates/template-management/TemplateManagement";
import {
  TemplateManagementConfig,
  TemplateTitleMaxLength,
} from "@/pages/system-settings/tabs/templates/template-management/TemplateManagement.types";
import { QueryKey } from "@/query/Query";
import { useTranslation } from "@/translations";

function TemplatesSettingsInner() {
  const { t } = useTranslation();

  const config = useMemo<TemplateManagementConfig>(
    () => ({
      queryKey: QueryKey.SmsTemplates,
      titleMaxLength: TemplateTitleMaxLength,
      api: {
        getAll: () => smsTemplatesApi.getAllSmsTemplates(),
        create: (values) =>
          smsTemplatesApi.createSmsTemplate({
            createSmsTemplateRequest: { title: values.title, content: values.content },
          }),
        update: (id, values) =>
          smsTemplatesApi.updateSmsTemplate({
            id,
            updateSmsTemplateRequest: { title: values.title, content: values.content },
          }),
        remove: (id) => smsTemplatesApi.deleteSmsTemplate({ id }),
      },
      labels: {
        selectTemplate: t("settings.templates.selectTemplate"),
        addTemplate: t("settings.templates.addTemplate"),
        title: t("settings.templates.title"),
        content: t("settings.templates.content"),
        noTemplateSelected: t("settings.templates.noTemplateSelected"),
        noTemplates: t("settings.templates.noTemplates"),
        saveSuccess: t("settings.templates.saveSuccess"),
        saveError: t("settings.templates.saveError"),
        createSuccess: t("settings.templates.createSuccess"),
        createError: t("settings.templates.createError"),
        deleteSuccess: t("settings.templates.deleteSuccess"),
        deleteError: t("settings.templates.deleteError"),
        deleteConfirmTitle: t("settings.templates.deleteConfirmTitle"),
        deleteConfirmText: t("settings.templates.deleteConfirmText"),
      },
    }),
    [t]
  );

  return <TemplateManagement config={config} />;
}

export const TemplatesSettings = withAuthorization(TemplatesSettingsInner, UserPermission.Supervisor);
